import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {Container, Grid, GridColumn, Icon, Button} from "semantic-ui-react";
import classnames from "classnames";
import MobileApplyNow from "./common/MobileApplyNow";
import ApplyNow from "./common/ApplyNow";

class VideoTips extends PureComponent {
  static propTypes = {
    show: PropTypes.object,
    page: PropTypes.object,
    season: PropTypes.object,
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  constructor(props) {
    super(props);
    this.state = {
      tabIndex: 0,
      visible: false,
    };
  }

  toggleVisibility = () => this.setState({ visible: !this.state.visible });

  closeMenu = () => this.setState({ visible: false });

  setTabIndex = index => {
    this.setState({ tabIndex: index });
  };

  renderTips(tips) {
    return (
      <GridColumn className="ui sixteen wide mobile five wide computer right floated tablet-up">
        <div className="ui fluid card noShadow tip">
          <div
            className="content invertedPrimary"
            style={{ backgroundColor: `#${this.props.season.hexColorCodeC}` }}
          >
            <div className="header">
              <h4>Tip</h4>
            </div>
          </div>
          <div
            className="content shaded padded"
            dangerouslySetInnerHTML={{ __html: tips }}
          />
        </div>
      </GridColumn>
    );
  }

  fixPageContent(pageContent) {
    pageContent = pageContent.split("target=\"_blank\"");

    for (let content in pageContent) {
      if (pageContent.length !== parseInt(content) + 1 && !pageContent[content].includes("mailto:")) {
        pageContent[content] += "target=\"_blank\"";
      }
    }

    return pageContent.join();
  }

  render() {
    const { show, page, season } = this.props;
    const tips = page && page.tipsC ? this.renderTips(page.tipsC) : '';
    let pageContent = '';
    if (page && page.pageContentC) {
      pageContent = this.fixPageContent(page.pageContentC);
    }

    if (page) {
      return (
        <div>
          <Container id="mainContent" className="ui">
            <Grid className="ui">
              <GridColumn className="pageShowTitle">
                <h3
                  className="ui dividing header"
                  style={{ color: `#${season.hexColorCodeC}` }}
                >
                  {show.name} Casting
                </h3>
                <Button
                  onClick={this.toggleVisibility}
                  id="applyToggle"
                  className="tiny ui primary tablet-down mobileToggle"
                >
                  <Icon className="sidebar" />
                  Apply Now
                </Button>
              </GridColumn>
            </Grid>

            <MobileApplyNow
              season={season}
              visible={this.state.visible} toggleVisibility={this.toggleVisibility} />

            <Grid className="ui stackable" onClick={this.closeMenu}>
              <GridColumn className="ui sixteen wide mobile eight wide computer">
                <h1>{page.pageTitleC}</h1>

                <p className="lead">{page.leadParagraphC}</p>

                <style>{"\
                .inner-html a {\
                  color:#" + season.hexColorCodeC + " !important;\
                }\
              "}</style>

                <div className="inner-html" dangerouslySetInnerHTML={{ __html: pageContent}} />

                <div className="ui hidden divider" />

                <div className="ui top attached tabular menu shaded">
                  <div
                    style={{ color: `#${season.hexColorCodeC}` }}
                    className={classnames('item', {
                      active: this.state.tabIndex === 0,
                    })}
                    onClick={() => this.setTabIndex(0)}
                  >
                    Lighting Tips
                  </div>
                  <div
                    style={{ color: `#${season.hexColorCodeC}` }}
                    className={classnames('item', {
                      active: this.state.tabIndex === 1,
                    })}
                    onClick={() => this.setTabIndex(1)}
                  >
                    Audio Tips
                  </div>
                  <div
                    style={{ color: `#${season.hexColorCodeC}` }}
                    className={classnames('item', {
                      active: this.state.tabIndex === 2,
                    })}
                    onClick={() => this.setTabIndex(2)}
                  >
                    Camera Tips
                  </div>
                </div>
                <div
                  className={classnames(
                    'ui bottom attached tab segment shaded',
                    {
                      active: this.state.tabIndex === 0,
                    }
                  )}
                >
                  <div className="ui vertical steps borderless reduced">
                    <div className="step">
                      <h3 style={{ color: `#${season.hexColorCodeC}` }}>1</h3>
                      <div className="content">
                        <div className="description">
                          If shooting indoors, make sure to shoot in a well lit
                          room with lights in front of you to light your face.
                        </div>
                      </div>
                    </div>
                    <div className="step">
                      <h3 style={{ color: `#${season.hexColorCodeC}` }}>2</h3>
                      <div className="content">
                        <div className="description">
                          Avoid shooting in front of a window with bright
                          sunlight streaming in. This will cause silhouetting.
                        </div>
                      </div>
                    </div>
                    <div className="step">
                      <h3 style={{ color: `#${season.hexColorCodeC}` }}>3</h3>
                      <div className="content">
                        <div className="description">
                          When shooting outdoors, avoid shooting with the sun
                          directly behind you. This will also cause
                          silhouetting.{' '}
                        </div>
                      </div>
                    </div>
                    <div className="step">
                      <h3 style={{ color: `#${season.hexColorCodeC}` }}>4</h3>
                      <div className="content">
                        <div className="description">
                          Shoot during the day so we can see you instead of
                          trying to see you in the dark.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={classnames(
                    'ui bottom attached tab segment shaded',
                    {
                      active: this.state.tabIndex === 1,
                    }
                  )}
                  data-tab="audio"
                >
                  <div className="ui vertical steps borderless reduced">
                    <div className="step">
                      <h3 style={{ color: `#${season.hexColorCodeC}` }}>1</h3>
                      <div className="content">
                        <div className="description">
                          Speak loudly and clearly.
                        </div>
                      </div>
                    </div>
                    <div className="step">
                      <h3 style={{ color: `#${season.hexColorCodeC}` }}>2</h3>
                      <div className="content">
                        <div className="description">
                          Find a relatively quiet area to shoot your video so
                          ambient noises won’t distract from what you’re saying.
                        </div>
                      </div>
                    </div>
                    <div className="step">
                      <h3 style={{ color: `#${season.hexColorCodeC}` }}>3</h3>
                      <div className="content">
                        <div className="description">
                          If shooting indoors, avoid shooting in loud and
                          crowded rooms where your voice will be drowned out by
                          other people.
                        </div>
                      </div>
                    </div>
                    <div className="step">
                      <h3 style={{ color: `#${season.hexColorCodeC}` }}>4</h3>
                      <div className="content">
                        <div className="description">
                          If shooting outdoors, avoid shooting in loud areas and
                          when it’s windy. The wind will distort the microphone.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={classnames(
                    'ui bottom attached tab segment shaded',
                    {
                      active: this.state.tabIndex === 2,
                    }
                  )}
                  data-tab="camera"
                >
                  <div className="ui vertical steps borderless reduced">
                    <div className="step">
                      <h3 style={{ color: `#${season.hexColorCodeC}` }}>1</h3>
                      <div className="content">
                        <div className="description">
                          Your video will be shown on a TV.&nbsp;&nbsp;Please shoot your
                          video like you would see it on a TV.&nbsp;&nbsp;Please shoot
                          landscape (horizontal) and not portrait (vertical)
                          style.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </GridColumn>

              <ApplyNow
                season={season}
              />

              {tips}
            </Grid>
          </Container>
        </div>
      );
    }
    return <div />;
  }
}

const mapStatesToProps = (state, ownProps) => ownProps;

export default connect(mapStatesToProps)(VideoTips);



// WEBPACK FOOTER //
// ./src/components/VideoTips.js